import React, { useMemo } from 'react';
import { Box, Divider, IconButton } from '@mui/material';
import { RiWhatsappFill, RiFacebookCircleFill, RiMailOpenFill, RiLinkM } from 'react-icons/ri';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { useDispatch } from 'react-redux';
import { setSnackbar } from 'redux/features/ui-slice';
import { Typography700 } from 'views/rebranded-module/common/components';
import copy from 'copy-to-clipboard';
import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
} from 'react-share';
import StyledBox from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/components/ShareSection/ShareSection.styles';

interface ShareSectionProps {
  blogTitle?: string;
}

const ShareSection: React.FC<ShareSectionProps> = (props) => {
  const { blogTitle } = props;
  const content = useContent('BlogDetailsPage');
  const dispatch = useDispatch();
  const currentUrl = useMemo(
    () => (typeof window !== 'undefined' ? window.location.href : ''),
    [],
  );

  const handleCopy = () => {
    if (currentUrl) {
      copy(currentUrl);
      dispatch(
        setSnackbar({
          open: true,
          message: content.linkCopiedText,
          severity: 'success',
        }),
      );
    }
  };
  return (
    <StyledBox>
      <Divider className="SSSDivider" />
      <Typography700 component="p" className="SSSTitle">
        {content.shareTitle}
      </Typography700>
      <Box className="SSSShareWrapper">
        <IconButton
          className="SSSIconButton"
          onClick={handleCopy}>
          <RiLinkM className="SSIcon" />
        </IconButton>
        <FacebookShareButton url={currentUrl} quote={blogTitle}>
          <IconButton className="SSSIconButton">
            <RiFacebookCircleFill className="SSIcon" />
          </IconButton>
        </FacebookShareButton>
        <WhatsappShareButton url={currentUrl} title={blogTitle}>
          <IconButton className="SSSIconButton">
            <RiWhatsappFill className="SSIcon" />
          </IconButton>
        </WhatsappShareButton>
        <EmailShareButton url={currentUrl} subject={blogTitle}>
          <IconButton className="SSSIconButton">
            <RiMailOpenFill className="SSIcon" />
          </IconButton>
        </EmailShareButton>
      </Box>
    </StyledBox>
  );
};

export { ShareSection };

